<template>
  <div class="spinner-loading">
    <div class="spinner"></div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@use '@common/style/variables' as *;

.spinner-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.spinner-loading .spinner {
  box-sizing: border-box;
  width: 60%;
  height: 60%;
  border: 4px solid $neutral-200;
  border-top-color: $neutral-400;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  flex-shrink: 0;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
